import {Card, CardCaption, CardTitle, EducationScreen, Gold, RevealBlock, ScreenIntro} from './EducationShell';
import {COMPOUNDED_TIMELINE_MILESTONES, TimelineViz} from './Step10Viz';
import styles from './Glp1EducationOutcomeCompounded.module.css';

/** Step 10 — compounded. Same hero/timeline structure as branded but with
 *  more conservative projections (Malhotra weight-loss → AHI model). */
export const Glp1EducationOutcomeCompounded = () => (
  <EducationScreen
    ctaLabel="Next"
    variant="compounded_v1"
    analyticsShown="GLP-1 Funnel Education Outcome Viewed"
    analyticsSubmitted="GLP-1 Funnel Education Outcome Continue Tapped"
  >
    <ScreenIntro
      headline={
        <>
          Week by week, <Gold>sleep interruptions</Gold> decrease.
        </>
      }
      subhead={
        <>
          Severe untreated sleep apnea typically means ≥30 breathing events per hour.{' '}
          <span className={styles.citation}>(AHI severity thresholds, American Academy of Sleep Medicine)</span>
        </>
      }
    />

    <RevealBlock delayMs={300}>
      <Card>
        <CardTitle>
          How <Gold>progress</Gold> builds
        </CardTitle>
        <TimelineViz milestones={COMPOUNDED_TIMELINE_MILESTONES} delayMs={200} />
        <CardCaption>
          Projections model AHI improvement from semaglutide-driven weight loss based on Peppard et al. (2000): ~26% AHI
          reduction per 10% weight loss. Individual response varies. Compounded sublingual semaglutide has not been
          studied in dedicated OSA trials.
        </CardCaption>
      </Card>
    </RevealBlock>
  </EducationScreen>
);

export default Glp1EducationOutcomeCompounded;
